import React, { useEffect, useState } from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CatPagination from '../../../../Website/utils/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { getRecievedEnquirydetailsThunk, setRecievePage } from '../../../../Website/redux/recievedEnquiriesSlice';
import AllVendorOrderTable from '../../../VendorDash/Components/orderscomp/AllVendorOrderTable';
import { exportRecievedOrderdetailsThunk, getReceivedOrdersThunk, setRecievedOrderStatus, setRecieveOrderPage } from '../../../../Website/redux/receivedVendorOrderSlice';
import { exportDataExcel, formateDate } from '../../../../Website/utils/utils';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '014px',
    color: '#667085',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    borderRadius: "4px",
    height: "40px",
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const statuss = ['NEW', 'QUOTED', 'COMPLETED']
const RecievedOrderTab = ({ attributes, additionalResources, setStatus, }) => {
    const [activeTab, setActiveTab] = useState('BOM');
    const tabs = ['BOM', 'Wizard', 'ExcessInventory'];
    const [anchorEl, setAnchorEl] = useState(null);
    const [limit, setLimit] = useState(25)
    const open = Boolean(anchorEl);
    const { orders, page, refresh, loading, status } = useSelector(state => state.receivedOrders)
    const data = orders?.data
    const totalPages = orders?.totalPages
    const totalItems = orders?.totalItems
    const itemsPerPage = orders?.limit
    const dispatch = useDispatch()
      const [exportLoading, setExportLoading] = useState(false)

    // calculate start & end of items -------------------
    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    console.log(orders);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (status) => {
        if (status) {
             dispatch(setRecievedOrderStatus(status))
        }
        setAnchorEl(null);
    };




    useEffect(() => {
        dispatch(getReceivedOrdersThunk(`?page=${page}&limit=${limit}&status=${status}`))
    }, [refresh, activeTab, page, limit, status])

    const exportbomenq = async () => {
        setExportLoading(true)
        const status = await dispatch(exportRecievedOrderdetailsThunk(`?limit=${1000000000000000}`))
        setExportLoading(false)
        console.log(status);
    
        if (status?.payload?.success === true) {
          console.log("status", status?.payload?.data);
    
          const exportOrderData = status?.payload?.data
          const exportdata = exportOrderData?.map((item) => ({
            'id': item?._id || '-',
            // 'products': item?.partList?.length + 'products',
            'Status': item?.status || '-',
            'CreatedAt': formateDate(item?.createdAt),
          }))
          console.log("expo", exportdata);
    
          exportDataExcel(exportdata, "ReceivedOrders")
        }
      }

    return (
        <>
            <section className={styles.receivedEnquiries}>
                <div className={styles.receivedEnquiriesHeader}>
                    <div>
                        <span className={styles.receivedEyebrow}>VENDOR WORKSPACE</span>
                        <h2>Received orders</h2>
                        <p>Track order fulfilment, review status updates, and manage every customer order.</p>
                    </div>

                    <div className={styles.receivedHeaderActions}>
                        <span className={styles.receivedCount}>{totalItems || 0} {totalItems === 1 ? 'order' : 'orders'}</span>
                        <div>
                            <ActionButton
                                className={styles.receivedFilterButton}
                                onClick={handleClick}
                                sx={{
                                    color: '#667085',
                                    border: '1px solid #E0E2E7',
                                    background: '#fff',
                                    borderRadius: '8px',
                                }}
                            >
                                <Filter /> {status ? status :"Filters"}
                            </ActionButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={() => handleClose('')}
                                MenuListProps={{
                                    'aria-labelledby': 'status-button',
                                }}
                            >
                                {statuss.map((i) => (
                                    <MenuItem onClick={() => handleClose(i)}
                                        sx={{
                                            borderBottom: '1px solid #E6E1E5',
                                            fontSize: '14px',
                                            color: '#667085',
                                        }}>{i}</MenuItem>
                                ))
                                }
                            </Menu>
                        </div>
                        <button className={styles.receivedDownloadButton} onClick={exportbomenq} disabled={exportLoading}><Download /> {exportLoading ? "Please wait..." : "Download"}</button>
                    </div>

                </div>
                <div className={styles.receivedEnquiriesContent}>
                    {/* <div className={styles.spectabs}>
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                className={`${styles.spectabButton} ${activeTab === tab ? styles.active : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab === 'BOM' && 'BOM'}
                                {tab === 'Wizard' && 'Wizard'}
                                {tab === 'ExcessInventory' && 'ExcessInventory'}
                            </button>
                        ))}
                    </div> */}
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
                                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
                            </div>
                            :
                            <>
                                {data?.length > 0 ?

                                    <AllVendorOrderTable data={data} tableStyles={styles} />
                                    :
                                    <div className={styles.receivedEmpty}>
                                        <strong>No orders available</strong>
                                        <span>New orders will appear here as soon as they are received.</span>
                                    </div>
                                }
                            </>
                    }
                </div>
                {data?.length > 0 &&
                    <CatPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        start={start}
                        end={end}
                        page={page}
                        setPage={setRecieveOrderPage}
                    />
                }
            </section>
        </>
    );
};

export default RecievedOrderTab;


